import React from 'react'
import classes from './Person.css'

const person = ( props ) => {

    // const style = {
    //     '@media (min-width: 500px)': {
    //         width: '450px'
    //     }
    // }
    const rnd = Math.random();
    if (rnd > 0.7) {
        throw new Error('Sum Ting Wong!')
    }

    return (
        // <div className="Person" style={style}>
        <div className={classes.Person}>
            <p onClick={props.click}>Я {props.iam}, я не {props.iamnot}!</p>
            <p>{props.children}</p>
            <input type="text" onChange={props.changed} value={props.iam} />
        </div>
    )
}

export default person


// WEBPACK FOOTER //
// ./src/Person/Person.js